import styled from 'styled-components'

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 900px;
  width: 90%;
`
